module.exports = __webpack_public_path__ + "static/media/green-blue.0aded5be.png";